import React, { useEffect, useState } from 'react';
import styles from './premium-item.module.scss';
import clsx from 'clsx';
import { CheckEmptyIcon, CheckIcon, StarPremiumIcon } from '@/assets/icons';
import { Typography } from '@/ui-kit';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@/store/useAuth';
import { Format } from '@/utils/translations';

interface Props {
    isActive?: boolean;
    date: string;
    priceInStars: string | number;
    saving?: string;
    isPopular?: boolean;
    isProfit?: boolean;
    price?: any;
    discount?: number;
    onClick?: () => void;
}

export const PremiumItem: React.FC<Props> = ({
    isActive,
    date,
    priceInStars,
    saving,
    isPopular,
    isProfit,
    price,
    discount,
    onClick,
}) => {
    const { t } = useTranslation();

    const userData = useAuth(state => state.getUser());

    const [format, setFormat] = useState<Format | null>(null)

    useEffect(() => {
        if (userData) setFormat(new Format(userData.lang))
    }, [userData])

    return (
        <button
            type="button"
            onClick={onClick}
            className={clsx(styles.premiumItem, isActive && styles.active)}>
            <div className={styles.dateBlock}>
                {isActive ? (
                    <CheckIcon
                        width={20}
                        height={20}
                        className={styles.iconCenter} />
                ) : (
                    <CheckEmptyIcon
                        width={20}
                        height={20}
                        className={styles.iconCenter} />
                )}
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-end',
                    gap: 1,
                    textAlign: 'left'
                }}>
                    <Typography
                        fontWeight="semibold"
                        fontFamily="SFProText"
                        typeColor={isActive ? 'white' : 'black'}
                        className={styles.subTitle}>
                        {date}
                    </Typography>
                    {
                        price && format ?
                            <span className={styles.price}>
                                {format.formatCurrency(price, { approx: true })}
                            </span>
                        :
                            <></>
                    }
                </div>
                {isProfit && (
                    <Typography
                        uppercase
                        className={styles.badge}
                        typeColor="white"
                        fontFamily="SFProText">
                        {t('profit')}
                    </Typography>
                )}
                {isPopular && (
                    <Typography
                        uppercase
                        className={styles.badge}
                        typeColor="white"
                        fontFamily="SFProText">
                        {t('popular')}
                    </Typography>
                )}
            </div>
            {
                format &&
                <div className={styles.priceBlock}>
                    <Typography
                        fontFamily="SFProText"
                        className={styles.priceText}
                        typeColor={isActive ? 'white' : 'black'}>
                        {format.formatNumber(+priceInStars)}
                    </Typography>
                    <StarPremiumIcon width={16} height={16} />
                </div>
            }
            {saving && <div className={styles.savingLabel}>{saving}</div>}
            {
                discount ?
                    <div className={styles.discount}>
                        {
                            [
                                '-',
                                discount,
                                '%',
                            ].join('')
                        }
                    </div>
                :
                    <></>
            }
        </button>
    );
};
